import { BUILD_ID, IS_LIVE_PROD } from 'config/envVariable';

const fontLoader = () => {
    // 載入 Icon Font 字型
    const iconLink = document.createElement('link');
    const hash = BUILD_ID ? `?${BUILD_ID}` : '';
    // prod 走正式路徑，其餘環境（dev/stage/local）都走 /dev/ 子路徑。
    const iconFontPath = IS_LIVE_PROD ? 'icon-font' : 'dev/icon-font';
    iconLink.href = `https://utility.fevercdn.com/${iconFontPath}/fever-icon-font.css.gz${hash}`;
    // 'stylesheet preconnect' 是無效的 rel 組合，瀏覽器無法正確解析；rel 應為 'stylesheet'。
    iconLink.rel = 'stylesheet';
    iconLink.crossOrigin = 'anonymous';
    document.head.appendChild(iconLink);

    // 載入 google 字型：改用依 unicode-range 切片的 fonts-subset.css，只下載頁面用到的字符片段。
    const fontLink = document.createElement('link');
    fontLink.href = 'https://utility.fevercdn.com/font/style/fonts-subset.css';
    fontLink.rel = 'stylesheet';
    fontLink.crossOrigin = 'anonymous';

    document.head.appendChild(fontLink);
};

export default fontLoader;
